import React from 'react'
import {
    Table,
    TableHeader,
    TableHeaderCell,
    TableRow,
    TableCell,
    TableBody,
    TableCellLayout,
    tokens,
    makeStyles,
    useTableFeatures,
    useTableSort,
    TableColumnId,
    TableColumnDefinition,
    createTableColumn,
    Field,
    shorthands,
    FluentProvider,
    webLightTheme,
    Button
    
  } from "@fluentui/react-components";

import Chip from '@mui/material/Chip';
import { MeetNowFilled } from "@fluentui/react-icons";


const useStyles = makeStyles({
    root: {
      backgroundColor: tokens.colorSubtleBackgroundHover
    },
    cell: {
      display: 'flex',
      justifyContent: 'center'
    },
    fieldWrapper: {
      ...shorthands.padding(
        tokens.spacingVerticalMNudge,
        tokens.spacingHorizontalMNudge
      ),
    },
});

const items = [
    {
      Title: { label: "Meeting 1" },
      Start: { label: "2019-11-20T13:00:00.0000000" },
      End: { label: "2019-11-20T13:00:00.0000000" },
      Action: {
        label: "Join",
        button: <Button
                appearance="primary"
                aria-label="Join"
                icon={<MeetNowFilled />}
                iconPosition="before"
              >Join Meeting</Button>
      },
    },
    {
    Title: { label: "Meeting 2" },
    Start: { label: "2019-11-20T13:00:00.0000000" },
    End: { label: "2019-11-20T13:00:00.0000000" },
    Action: {
        label: "Join",
        button: <Button
                appearance="primary"
                aria-label="Join"
                icon={<MeetNowFilled />}
                iconPosition="before"
              >Join Meeting</Button>
    },
    },
    {
    Title: { label: "Meeting 3" },
    Start: { label: "2019-11-20T13:00:00.0000000" },
    End: { label: "2019-11-20T13:00:00.0000000" },
    Action: {
        label: "Join",
        button: <Button
                  appearance="primary"
                  aria-label="Join"
                  icon={<MeetNowFilled />}
                  iconPosition="before"
                >Join Meeting</Button>
    },
    },
    {
    Title: { label: "Meeting 4" },
    Start: { label: "2019-11-20T13:00:00.0000000" },
    End: { label: "2019-11-20T13:00:00.0000000" },
    Action: {
        label: "Join",
        button: <Button
                  appearance="primary"
                  aria-label="Join"
                  icon={<MeetNowFilled />}
                  iconPosition="before"
                >Join Meeting</Button>
    },
    },
    {
    Title: { label: "Meeting 5" },
    Start: { label: "2019-11-20T13:00:00.0000000" },
    End: { label: "2019-11-20T13:00:00.0000000" },
    Action: {
        label: "Join",
        button: <Button
                appearance="primary"
                aria-label="Join"
                icon={<MeetNowFilled />}
                iconPosition="before"
              >Join Meeting</Button>
    },
    },
    
];
  

  const columns = [
    createTableColumn({
      columnId: "Title",
      compare: (a, b) => {
        return a.Title.label.localeCompare(b.Title.label);
      },
    }),
    createTableColumn({
      columnId: "Start",
      compare: (a, b) => {
        return a.Start.label.localeCompare(b.Start.label);
      },
    }),
    createTableColumn({
      columnId: "End",
      compare: (a, b) => {
        return a.End.label.localeCompare(b.End.label);
      },
    }),
    createTableColumn({
      columnId: "Action",
      compare: (a, b) => {
        return a.Action.label.localeCompare(b.Action.label);
      },
    }),
];
  
  

function MeetingList({meetingList}) {

    const styles = useStyles();

    const [searchQuery, setSearchQuery] = React.useState("");

    const formatDateTime = (isoString) => {
      const date = new Date(isoString);
      return new Intl.DateTimeFormat("en-US", {
        dateStyle: "medium",
        timeStyle: "short",
      }).format(date);
    };
    

    const {
      getRows,
      sort: { getSortDirection, toggleColumnSort, sort },
    } = useTableFeatures(
      {
        columns,
        items: meetingList.map((meeting) => ({
          Title: { label: meeting.subject },
          Start: { label: formatDateTime(meeting.startdatetime) },
          End: { label: formatDateTime(meeting.enddatetime) },
          Action: {
            label: "Join",
            button: (
              <Button
                appearance="primary"
                aria-label="Join"
                icon={<MeetNowFilled />}
                iconPosition="before"
                onClick={() => window.open(meeting.joinurl, '_blank')}
              >
                Join Meeting
              </Button>
            ),
          },
        })),
      },
      [
        useTableSort({
          defaultSortState: { sortColumn: "Title", sortDirection: "ascending" },
        }),
      ]
    );
    

    const headerSortProps = (columnId) => ({
        onClick: (e) => {
          toggleColumnSort(e, columnId);
        },
        sortDirection: getSortDirection(columnId),
    });

    const rows = sort(getRows());

    const filteredRows = rows.filter((row) =>
        Object.values(row.item).some((cell) => {
        if ('label' in cell) {
            return cell.label.toLowerCase().includes(searchQuery.toLowerCase());
        }
        })
    );
      

    return (
        <FluentProvider theme={webLightTheme}>

            <Table aria-label="List table" className={styles.root}>
                <TableHeader>
                <TableRow>
                    {columns.map((column) => (
                        <TableHeaderCell
                            key={column.columnId}
                            {...(column.columnId !== "Action" ? headerSortProps(column.columnId) : {})}
                        >
                            {column.columnId}
                        </TableHeaderCell>
                    ))}
                </TableRow>
                </TableHeader>
                <TableBody>
                {filteredRows.map((item, index) => (
                    <TableRow key={index}>
                    <TableCell>
                        <TableCellLayout>
                        {item.item.Title.label}
                        </TableCellLayout>
                    </TableCell>
                    <TableCell>
                        <TableCellLayout>
                        {item.item.Start.label}
                        </TableCellLayout>
                    </TableCell>
                    <TableCell>
                        <TableCellLayout>
                        {item.item.End.label}
                        </TableCellLayout>
                    </TableCell>
                    <TableCell>
                        <TableCellLayout media={item.item.Action.button}>
                            {/* {item.item.Action.label} */}
                        </TableCellLayout>
                    </TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </Table>
        
        </FluentProvider>
    )
}

export default MeetingList
